import React, { useState } from 'react';
import { RiHome5Line } from 'react-icons/ri';
import FilterDropdown from './FilterDropdown';

const propertyOptions = [
    { label: 'Property (any)', value: 'Property (any)' },
    { label: 'House', value: 'House' },
    { label: 'Apartament', value: 'Apartament' },
    { label: 'Villa', value: 'Villa' },
];

const PropertyDropdown = ({ onChange, isOpen, onToggle, onClose, className }) => {
    const [value, setValue] = useState(null);

    const handleSelect = (option) => {
        setValue(option);
        onClose();
        onChange(option);
    };

    return (
        <FilterDropdown
            icon={RiHome5Line}
            label="Property"
            value={value}
            options={propertyOptions}
            isOpen={isOpen}
            onToggle={onToggle}
            onClose={onClose}
            onSelect={handleSelect}
            className={className}
        />
    );
};

export default PropertyDropdown;
